import request, { postForm as postFormRequest, getBlob as getBlobRequest } from "../api";

export const get = (endpoint) => request(endpoint, 'GET');
export const post = (endpoint, data) => request(endpoint, 'POST', data);
export const put = (endpoint, data) => request(endpoint, 'PUT', data);
export const del = (endpoint) => request(endpoint, 'DELETE');

/** Multipart uploads; goes through the same auth and branch headers as the rest. */
export const postForm = (endpoint, formData) => postFormRequest(endpoint, formData);

/** Binary downloads such as CSV exports. */
export const getBlob = (endpoint) => getBlobRequest(endpoint);
